module.exports = __webpack_public_path__ + "img/e486485.png";